module.exports = __webpack_public_path__ + "src/assets/games/10/468.jpg";